import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../../../../reducers";
import {ConfigApi} from "../../../../../../../services/Api/types";
import {getStoreConfigLoyalty} from "../../../../../../../services/Store/reducer";
import {getUser} from "../../../../../../../services/User/reducer";
import NavbarMulti from "../../../../../../../components/Navbar/NavbarMulti";
import {getSession} from "../../../../../../../services/Session/reducer";

import Hero from "../../../../../../../components/Common/Hero";
import {usePlaceContext} from "../../../../../../../services/Place/PlaceContext";
import Footer from "../../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../../services/languageUtils";
import {useNavigate} from "react-router-dom";
import FetchPlaces from "../../../../../../../components/Fetch/FetchPlaces";

interface OwnProps {
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const MultistoreWithMapHomePage = ({config}: Props) => {
    const {places} = usePlaceContext();
    const navigate = useNavigate();

    const navigateToMapPage = () => navigate("/map");

    return (
        <div className="multistore-home-page multistore-with-map-home-page">
            <NavbarMulti config={config}/>
            <FetchPlaces>
                <div className="inner-container">
                    <Hero config={config} places={places || []} onButtonClick={navigateToMapPage}/>
                </div>
            </FetchPlaces>
            <Footer config={config} languages={getLanguagesBasedOnStoreType(config)} withoutMap/>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user),
    config_loyalty: getStoreConfigLoyalty(state.config),
    session: getSession(state.session)
})

const connector = connect(mapStateToProps);

export default connector(MultistoreWithMapHomePage);